import { render, staticRenderFns } from "./DateRangeLabel.vue?vue&type=template&id=5c9bfc35&"
import script from "./DateRangeLabel.vue?vue&type=script&lang=js&"
export * from "./DateRangeLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports